import { motion } from "framer-motion";
import { ChapterLabel } from "@/components/Expertise";
import { useLanguage } from "@/i18n/LanguageContext";

const PHOTO = "https://customer-assets-agu9un31.emergentagent.net/job_olena-gurova-pro/artifacts/sm7xp6y7_lolo%20v2.jpg";

export default function About() {
  const { t } = useLanguage();

  return (
    <section id="apropos" data-testid="about-section" className="bg-[#F1EFE9] py-24 lg:py-36">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <ChapterLabel num="05" title={t("about.label")} />
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -24 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9 }}
            className="lg:col-span-4 relative max-w-sm"
          >
            <div className="absolute -bottom-4 -right-4 w-full h-full border border-brass/50 pointer-events-none" />
            <div className="overflow-hidden aspect-[3/4] bg-slate2">
              <img
                data-testid="about-photo"
                src={PHOTO}
                alt={t("about.alt")}
                className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700"
              />
            </div>
            <p className="mt-4 text-[11px] uppercase tracking-[0.25em] text-ink/40">Oléna Gurova-Vacher</p>
          </motion.div>
          <div className="lg:col-span-8">
            <motion.blockquote
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.8 }}
              className="font-serif font-light text-3xl sm:text-4xl lg:text-5xl leading-[1.15] tracking-tight text-ink"
            >
              {t("about.quoteA")}<em className="text-brass not-italic">{t("about.quoteB")}</em>{t("about.quoteC")}
            </motion.blockquote>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: 0.15 }}
              className="mt-8 max-w-2xl space-y-5 text-base leading-relaxed text-ink/70"
            >
              <p>{t("about.p1")}</p>
              <p>{t("about.p2")}</p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
